/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

export const A_KEY_CODE = 65;
export const z_KEY_CODE = 122;
export const Z_KEY_CODE = 90;
export const a_KEY_CODE = 97;
